import useTranslation from 'next-translate/useTranslation';

import { Box, Icon, LinkTranslatedStyledAsLink, Paper, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, EColor, EIcon, ERouting } from '@core/type';

export const ContactUsBanner = () => {
  const { isPhone } = useContextMediaQuery();
  const { t } = useTranslation(Translate.page.FAQ);

  return (
    <LinkTranslatedStyledAsLink keyRoute={ERouting.CONTACT}>
      <Paper
        padding={isPhone ? '30px 46px' : '20px'}
        backgroundColor={EColor.INFO}
        borderRadius={'6px'}
        cursor={'pointer'}
      >
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={isPhone ? 'column' : 'row'}
          textAlign={'center'}
        >
          <Icon
            type={EIcon.CONTACT}
            width={'46px'}
            height={'46px'}
            marginRight={isPhone ? '0' : '16px'}
            marginBottom={isPhone ? '4px' : '0'}
          />
          <Typography marginRight="5px">
            {`${t('needHelp')} `}
            <Typography textDecoration="underline" as={EActionAttribute.SPAN}>
              {t('contactUs')}
            </Typography>
          </Typography>
        </Box>
      </Paper>
    </LinkTranslatedStyledAsLink>
  );
};
